import { Component, computed, input } from '@angular/core';

import { FileProperties } from 'common/files/file-properties';

@Component({
  selector: 'comp-file-type',
  templateUrl: './file-type-label.component.html',

  styleUrls: ['./file-type-label.component.scss'],
})
export class FileTypeLabelComponent {
  file = input.required<FileProperties>();

  readonly fileTypeOrExtension = computed(() => {
    if (this.file().filetype) {
      switch (this.file().filetype) {
        case 'image/png':
          return 'PNG';
        case 'image/jpeg':
          return 'JPEG';
        case 'image/gif':
          return 'GIF';
        case 'image/webp':
          return 'WEBP';
        case 'image/tiff':
          return 'TIFF';
        case 'image/bmp':
          return 'BMP';
        case 'image/svg+xml':
          return 'SVG';
        case 'application/pdf':
          return 'PDF';
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          return 'DOCX';
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          return 'XLSX';
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          return 'PPTX';
        case 'application/json':
          return 'JSON';
        case 'application/xml':
          return 'XML';
        case 'text/xml':
          return 'XML';
        case 'application/rdf+xml':
          return 'RDF';
        case 'application/vnd.cyclonedx+json':
          return 'CYCLONEDX JSON';
        case 'application/vnd.cyclonedx+xml':
          return 'CYCLONEDX XML';
        case 'application/spdx+json':
          return 'SPDX JSON';
        case 'application/spdx+xml':
          return 'SPDX XML';
        case 'text/plain':
          return 'TXT';
        default:
          return this.file().filetype;
      }
    }

    return this.getNormalizedAndShortenedFileExtension(this.file().filename);
  });

  private getNormalizedAndShortenedFileExtension(fileName: string) {
    const extension = fileName.split('.').pop();
    if (extension && extension !== fileName) {
      const normalizedExtension = extension.toUpperCase();
      return normalizedExtension.length > 7
        ? normalizedExtension.substring(0, 4) + '...'
        : normalizedExtension;
    }
    return 'UNKNOWN';
  }
}
